import { useEffect, useState } from 'react';
import { Tabs, Image, Spin } from 'antd';
import SettingComponent from '@/components/LogoSettings';
import { settingPictures } from '@/api/personCenter/organization';
import drawingTemplate from '@/assets/img/userCenter/drawingTemplate.png';
import templatePicture from '@/assets/img/userCenter/templatePicture.png';
import appStore from '@/store/appStore';
import { useStoreState } from '&/utils/customHooks';
import './LogoSettings.scss';

const { TabPane } = Tabs;

export default function LogoSettings() {
    const { organization = {} } = useStoreState('appStore');
    const [current, setCurrent] = useState(-1);
    const [watermarkIcon, setWaterMarkIcon] = useState('');
    const [logoIcon, setLogoIcon] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (+current === -1 || +current === 1) return;
        setIsLoading(true);
        settingPictures({
            type: current,
            dap: 1,
        })
            .then(res => {
                const { drawing_url, mark_url } = res.data;
                if (+current === 2) {
                    mark_url && setWaterMarkIcon(mark_url);
                } else if (+current === 3) {
                    drawing_url && setLogoIcon(drawing_url);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [current]);

    const clickHandler = tabIndex => {
        setCurrent(tabIndex);
    };

    const settingEnterpriseLogo = imageFile => {
        const fr = new FileReader();
        fr.readAsDataURL(imageFile);
        fr.onload = res => {
            const {
                target: { result },
            } = res;
            appStore.setLogoURL(result);
        };
    };

    const settingWatermark = imageFile => {
        const fr = new FileReader();
        fr.readAsDataURL(imageFile);
        fr.onload = res => {
            const {
                target: { result },
            } = res;
            setWaterMarkIcon(result);
        };
    };

    const settingLogoIcon = iconSrc => {
        setLogoIcon(iconSrc);
    };

    const disabled =
        organization.example === 0 && organization.roleFlag !== 'admin';

    return (
        <div
            type="card"
            className="base-card-page card logo-setting-info"
            title={intl.get('accountSetting.personalInfo')}>
            <div className="card-content">
                <Spin spinning={isLoading}>
                    <Tabs defaultActiveKey="1" onTabClick={clickHandler}>
                        <TabPane
                            tab={intl.get('logoSettings.tabs.enterprise')}
                            key="1">
                            <SettingComponent
                                disabled={disabled}
                                type={1}
                                callback={settingEnterpriseLogo}>
                                <div slot="notice">
                                    <p className="request message">
                                        {intl.get(
                                            'logoSettings.message.enterprise.request'
                                        )}
                                    </p>
                                    <div className="request__body">
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.enterprise.first'
                                            )}
                                        </p>
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.enterprise.second'
                                            )}
                                        </p>
                                        {/*<p className="body__message message">*/}
                                        {/*    {intl.get(*/}
                                        {/*        'logoSettings.message.enterprise.third'*/}
                                        {/*    )}*/}
                                        {/*</p>*/}
                                    </div>
                                    <p className="message">
                                        {intl.get(
                                            'logoSettings.message.enterprise.content'
                                        )}
                                    </p>
                                </div>
                            </SettingComponent>
                        </TabPane>
                        <TabPane
                            tab={intl.get('logoSettings.tabs.watermark')}
                            key="2">
                            <SettingComponent
                                type={2}
                                disabled={disabled}
                                callback={settingWatermark}>
                                <div slot="notice">
                                    <p className="request message">
                                        {intl.get(
                                            'logoSettings.message.watermark.request'
                                        )}
                                    </p>
                                    <div className="request__body">
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.watermark.first'
                                            )}
                                        </p>
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.watermark.second'
                                            )}
                                        </p>
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.watermark.third'
                                            )}
                                        </p>
                                        {/*<p className="body__message message">*/}
                                        {/*    {intl.get(*/}
                                        {/*        'logoSettings.message.watermark.forth'*/}
                                        {/*    )}*/}
                                        {/*</p>*/}
                                    </div>
                                </div>
                                <div slot="preview" className="picture-preview">
                                    <Image
                                        src={templatePicture}
                                        preview={false}
                                        alt="template_picture"
                                        className="picture-water-marker"
                                    />
                                    <div className="water-marker">
                                        {watermarkIcon && (
                                            <Image
                                                src={watermarkIcon}
                                                preview={false}
                                                alt="watermark_icon"
                                            />
                                        )}
                                    </div>
                                </div>
                            </SettingComponent>
                        </TabPane>
                        <TabPane
                            tab={intl.get('logoSettings.tabs.drawing')}
                            key="3">
                            <SettingComponent
                                type={3}
                                disabled={disabled}
                                callback={settingLogoIcon}>
                                <div slot="notice">
                                    <p className="request message">
                                        {intl.get(
                                            'logoSettings.message.drawing.request'
                                        )}
                                    </p>
                                    <div className="request__body">
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.drawing.first'
                                            )}
                                        </p>
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.drawing.second'
                                            )}
                                        </p>
                                        {/*<p className="body__message message">*/}
                                        {/*    {intl.get(*/}
                                        {/*        'logoSettings.message.drawing.third'*/}
                                        {/*    )}*/}
                                        {/*</p>*/}
                                    </div>
                                    <p className="request message">
                                        {intl.get(
                                            'logoSettings.message.drawing.note'
                                        )}
                                    </p>
                                    <div className="request__body">
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.drawing.firstNote'
                                            )}
                                        </p>
                                        <p className="body__message message">
                                            {intl.get(
                                                'logoSettings.message.drawing.secondNote'
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div slot="preview" className="drawing-preview">
                                    <Image
                                        src={drawingTemplate}
                                        preview={false}
                                        alt="drawing_template"
                                        className="drawing-water-marker"
                                    />
                                    <div className="logo-icon">
                                        {logoIcon && (
                                            <Image
                                                src={logoIcon}
                                                preview={false}
                                                alt="logo-icon"
                                            />
                                        )}
                                    </div>
                                </div>
                            </SettingComponent>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        </div>
    );
}
